<template>
    <div v-if="items.length > maxAmountVisible" class="tw-text-center tw-mt-4">
        <l-base-button
            :button-types="['primary', 'inline']"
            data-test-class="load-more"
            @click.native="onButtonClick"
        >
            <template v-if="this.value < items.length && this.value <= maxItems">
                <i class="fal fa-caret-down tw-mr-1" />
                <span>{{ $t("profile.notif.btnShowMore") }}</span>
            </template>
            <template v-else>
                <i class="fal fa-caret-up tw-mr-1" />
                <span>{{ $t("profile.notif.btnShowLess") }}</span>
            </template>
        </l-base-button>
    </div>
</template>

<script>
import LBaseButton from "@/components/LBaseButton";

export default {
    components: {
        LBaseButton,
    },
    props: {
        items: {
            type: Array,
            default: () => [],
        },
        value: {
            type: Number,
            required: true,
        },
        maxAmountVisible: {
            type: Number,
            default: 3,
        },
        maxItems: {
            type: Number,
            default: 50,
        },
        scrollToElement: {
            default: false,
        },
    },
    methods: {
        onButtonClick() {
            let newValue;

            if (this.maxAmountVisible === this.value) {
                newValue = this.items.length > this.maxItems ? this.maxItems : this.items.length;
            } else {
                newValue = this.maxAmountVisible;

                this.$nextTick(() => {
                    this.scrollToElement?.scrollIntoView?.({
                        block: "start",
                        behavior: "smooth",
                    });
                });
            }

            this.$emit("update:value", newValue);
        },
    },
};
</script>
